/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Method_Item1Inputs */

const ja_playdata_about_method_item1 = /** @type {(inputs: Playdata_About_Method_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独自に開発された技術に基づき収集したストリーミング配信のデータを収集。`)
};

const en_playdata_about_method_item1 = /** @type {(inputs: Playdata_About_Method_Item1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streaming data collected using technology we developed ourselves.`)
};

/**
* | output |
* | --- |
* | "Streaming data collected using technology we developed ourselves." |
*
* @param {Playdata_About_Method_Item1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_method_item1 = /** @type {((inputs?: Playdata_About_Method_Item1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Method_Item1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_method_item1(inputs)
	return en_playdata_about_method_item1(inputs)
});